import { render, staticRenderFns } from "./CategoryMainSlider.vue?vue&type=template&id=41855055&"
import script from "./CategoryMainSlider.vue?vue&type=script&lang=js&"
export * from "./CategoryMainSlider.vue?vue&type=script&lang=js&"
import style0 from "./CategoryMainSlider.vue?vue&type=style&index=0&id=41855055&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports